const selector = ".js-composite-field";

const instance = ($container: HTMLElement) => {
  // Extract separator from data attribute
  const separator = $container.dataset.sep ?? "/";

  // Find DOM elements
  const $hiddenInput = $container.querySelector<HTMLInputElement>(`${selector}-composite`);
  const $dayInput = $container.querySelector<HTMLInputElement>(`${selector}-day`);
  const $monthInput = $container.querySelector<HTMLInputElement>(`${selector}-month`);
  const $yearInput = $container.querySelector<HTMLInputElement>(`${selector}-year`);

  // Validate all inputs were found
  if (!$hiddenInput || !$dayInput || !$monthInput || !$yearInput) {
    console.error("Unable to find all composite date inputs");
    return;
  }

  // Update hidden input value based on day/month/year inputs
  const updateHiddenInput = () => {
    const day = $dayInput.value.padStart(2, "0");
    const month = $monthInput.value.padStart(2, "0");
    const year = $yearInput.value;

    // Only set value if all inputs have values
    if (day && month && year) {
      $hiddenInput.value = `${day}${separator}${month}${separator}${year}`;
    }
    else {
      $hiddenInput.value = "";
    }
  };

  // Add event listeners to each input
  [$dayInput, $monthInput, $yearInput].forEach((input) => {
    input.addEventListener("input", updateHiddenInput);
    input.addEventListener("change", updateHiddenInput);
  });

  // Initial validation setup
  updateHiddenInput();
};

export default () => {
  const $compositeDateContainers = document.querySelectorAll<HTMLElement>(selector);

  $compositeDateContainers.forEach(($element) => {
    instance($element);
  });
};
